import { render } from "./WorkButtons.vue?vue&type=template&id=e87037c8&scoped=true"
import script from "./WorkButtons.vue?vue&type=script&lang=js"
export * from "./WorkButtons.vue?vue&type=script&lang=js"

import "./WorkButtons.vue?vue&type=style&index=0&id=e87037c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e87037c8"]])

export default __exports__